import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { isDevMode } from '@angular/core';

// Restrict console logs in production mode
if (!isDevMode()) {
  window.console.log = () => { };
  window.console.info = () => { };
  window.console.debug = () => { };
  // console.warn and console.error are kept active for critical issue tracking
  // window.console.warn = () => {};
  // window.console.error = () => {};
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
